if(!customElements.get('featured-products')) {
  customElements.define(
    'featured-products',
    class FeaturedProducts extends HTMLElement {
      constructor() {
        super();
        this.sliderEl = this.querySelector('[data-slider]');
      }

      connectedCallback() {
        this.initSlider();
      }

      initSlider() {
        if(!this.sliderEl) {
          return console.error('An error ocurred while trying to initialize featured products slider');
        }

        this.sliderInstance = new Swiper(this.sliderEl, {
          slidesPerView: 1.1,
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: 3,
              spaceBetween: 16
            },
            1024: {
              slidesPerView: 4,
              spaceBetween: 16
            }
          },
          navigation: {
            prevEl: '.featured-products-slider-button.slider-button.prev',
            nextEl: '.featured-products-slider-button.slider-button.next',
          },
          pagination: {
            el: '.featured-products-slider-pagination',
            type: 'bullets',
            clickable: true
          }
        });
      }
    }
  );
}